<template>
  <div class="auth-forgot">
    <b-container>
      <b-row align-h="center">
        <b-col md="8">
          <b-card header="パスワード再発行">
            <b-form @submit.prevent="onSubmit">
              <b-form-group label="メールアドレス" label-cols-md="4" label-align-md="right">
                <b-col md="9">
                  <FormValidatorEmail name="メールアドレス" :form="$v.form.email" />
                </b-col>
              </b-form-group>

              <b-form-group>
                <b-col md="6" offset-md="4">
                  <b-button type="submit" variant="primary">メール送信</b-button>
                </b-col>
              </b-form-group>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { required, email, maxLength } from 'vuelidate/lib/validators';

export default {
  name: 'AuthForgot',

  computed: {
    ...mapState({
      form: state => state.auth.forgot,
    }),
  },

  validations: {
    form: {
      email: {
        required,
        email: email,
        maxLength: maxLength(255),
      },
    },
  },

  mounted() {
    this.$store.dispatch('auth/forgotClear');
  },

  methods: {
    onSubmit(evt) {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }
      this.$store.dispatch('auth/forgot', {
        form: this.form,
        callback: (data) => {
          this.$v.form.$reset();
          this.$store.dispatch('auth/forgotClear');
        },
      });
    },
  },
};
</script>

<style scoped>
</style>
